<template>
  <div :class="$style.NameMode" class="NameMode">
    <Form
      v-model="formData"
      :options="formOptions"
    >
      <template #btns>
        <el-button @click="onSearch">查询</el-button>
        <el-button @click="onReset">清空</el-button>
      </template>
    </Form>
    <el-tabs v-model="activeTab" @tab-click="onTabChange">
      <el-tab-pane
        v-for="(value, key) in tabs"
        :key="key"
        :name="key"
        :label="value.label"
      ></el-tab-pane>
    </el-tabs>
    <!--:pagerData="{
        allCount,
        pageCount,
        pageSize,
        page,
      }"
      @page-change="onPageChange" -->
    <div :class="$style.NameMode__Count" v-if="data">
      <span>总计划数：{{data.all_count}}</span>
      <span class="ml20">已分配数：{{data.assigned_count}}</span>
      <span class="ml20">剩余未分配数：{{data.undistributed_count}}</span>
      <span class="ml20">完成百分比：{{data.completion_ratio}}</span>
    </div>
    <Table :class="$style.NameMode__Table"
      :span-method="arraySpanMethod"
      class="NameMode__Table"
      v-loading='loading'
      :element-loading-text="'拼命加载中'"
      :keys="keysData"
      :data="list"
      :colOptions="colOptions"
    >
      <template #realname="{ row, item: colItem }">
        <span v-if="row.SPAN_TYPE !== 'add'">{{ row[colItem.prop] }}</span>
        <AddAllocationPlan v-else :list="list" @cancel="onAddCancel" :queue_id="item.queue_id" @update="onTabChange"/>
      </template>
    </Table>
    <i :class="$style.NameMode__add" v-if="activeTab === 'current' && isAddShow" @click="onAdd" class="el-icon-circle-plus"></i>
  </div>
</template>

<script>
import Form from '@/components/ZyForm.vue';
import Table from '@/components/ZyTable.vue'
import { formTable } from "@/mixin/formTable";
import { queueListName, listNameModify, listNameDel } from "./api";
import AllocationTimes from './AllocationTimes.vue';
import AddAllocationPlan from './AddAllocationPlan.vue'
import { hasPermission } from '@/permission/index'
export default {
  components: { Form, Table, AddAllocationPlan },
  mixins: [formTable],
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      tabs: {
        current: { label: '当前分配计划', status: 1, colOptionsName: 'curColOptions'  },
        already: { label: '已完成/已取消', status : 2, colOptionsName: 'alrColOptions' }
      },
      requestApi: queueListName,
      activeTab: 'current',
      formData: {
        realname: undefined,
        username: undefined,
        dep_id: undefined,
      },
      noPage: true,
      isAddShow: true,
      keysData: {
        id: '编号',
        realname: '员工姓名',
        username: '工号',
        dep: '部门',
        group: '组',
        team: '小队',
        times_set: '已分配数/计划数',
      }
    }
  },
  computed: {
    form:{
      set () {
        // do nothing
      },
      get () {
        return {
          ...this.formData,
          queue_id: this.item.queue_id,
          status: this.tabs[this.activeTab].status,
        }
      }
    },
    colOptions () {
      let colOptionsName = this.tabs[this.activeTab].colOptionsName
      return colOptionsName ? this[colOptionsName] : undefined
    },
    formOptions () {
      return ([
        {
          label: "员工姓名",
          prop: "realname",
        },
        {
          label: "工号",
          prop: "username",
        },
        {
          label: "组织架构",
          prop: "dep_id",
          type: "department",
          propOptions: {
            depType: 2,
            person: false,
            style: 'width: 250px'
          }
        },
      ])
    },
    curColOptions() {
      return ({
        id: { width: '80px' },
        realname: { type: 'slot', prop: 'realname', }, 
        times_set: { components: [
          { is: AllocationTimes, prop: 'times_set', propOptions: {
            queue_id: this.item.queue_id,
            disabled: !hasPermission('AllotModel_Button_AllocationTimesEdit')
          }}
        ]},
        operater: {
          label: '操作人', prop: 'operater'
        },
        operate_time: {
          label: '操作时间', prop: 'operate_time'
        },
        is_open: {
          label: '状态', components: [
          { is: `ElSwitch`, prop: 'is_open', change: this.onChangeStatus, propOptions: {
            activeColor: "#13ce66",
            activeValue: 1,
            inactiveValue: 2,
          }}
          ]
        },
        operate: { label: '操作', components: [
          { is: `ElButton`, text: '删除', click: this.onDel, propOptions: {
            type: "text",
          }}
        ]},
      })
    },
    alrColOptions() {
      return ({
        times_set: { components: [
          { is: AllocationTimes, prop: 'times_set', propOptions: {
            queue_id: this.item.queue_id,
            disabled: true,
          }}
        ]},
        status: { label: '状态', format: val => val === 3 ? '已取消' : '已完成'}
      })
    }
  },
  methods: {
    handleDefaultData(data) {
      this.data = data
      this.list = data?.list?.map(a => (
        {
          ...a, 
          realname: a.user?.realname,
          dep: a.user?.dep?.dep,
          group: a.user?.dep?.group,
          team: a.user?.dep?.team,
        }
      )) || []
    },
    onTabChange () {
      this.onSearch()
      this.isAddShow = true
    },
    onReset () {
      this.formData = this.$options.data().formData
    },
    onChangeStatus (row) {
      this.onApiCatch({
        api: listNameModify,
        params: {
          id: row.id,
          is_open: row.is_open,
        },
        loadingName: 'modifyLoading',
        loadingThis: row,
        onError: () => {
          row.is_open = row.is_open === 1 ? 2 : 1
        }
      })
    },
    async onDel (row) {
      await this.$confirm(`即将取消【${row.username}】的接入计划，确认取消吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      this.onApiCatch({
        api: listNameDel,
        params: {
          id: row.id,
        },
        loadingName: 'delLoading',
        loadingThis: row,
        onSuccess: () => {
          this.onGetList()
          this.isAddShow = true
        }
      })
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.SPAN_TYPE === 'add') {
        if ( columnIndex === 0) {
          return [ 1, 1]
        } else if ( columnIndex === 1) {
          let length = Object.keys({...this.keysData, ...this.colOptions})?.length - 1
          return [1, length]
        } else {
          return [0, 0]
        }
      }
    },
    onAdd () {
      // let length = this.list?.length || 0
      this.isAddShow = false
      this.list.push({
        // id: length + 1,
        id: '-',
        SPAN_TYPE: 'add'
      })
    },
    onAddCancel () {
      this.list.pop()
      this.isAddShow = true
    },
  }
}
</script>

<style lang="scss" module>
.NameMode {
  padding-top: 20px;
}
.NameMode__Count {
  text-align: right;
  color: #101010;
  font-size: 14px;
  margin-bottom: 5px;
}
.NameMode__Table {
  padding: 0;
}
.NameMode__add {
  font-size: 24px;
  cursor: pointer;
}
.NameMode__addBox__index {
  width: 100px;
  height: 100%;
  border-right: 1px solid #EBEEF5;
}
.NameMode__addBox {
  display: flex;
  height: 63px;
  border: 1px solid #EBEEF5;
  border-top: 0;
  border-left: 0;
}

</style>

<style lang="scss">
  .NameMode .el-tabs__nav-scroll::after {
    display: none;
  }
</style>